<div class="report-page">
  <div class="report-page__header">
    <span class="report-page__title flex justify-start items-center text-black font-black uppercase">
      Relatório - Colaboradores
    </span>

    <div class="filters-toolbar filters-toolbar--inline">
      <button
        (click)="showFilters = !showFilters"
        class="toolbar-btn btn filters-toggle-btn"
        [class.filters-toggle--active]="showFilters"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-4 h-4"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="9" cy="6" r="2" />
          <line x1="4" y1="6" x2="7" y2="6" />
          <line x1="11" y1="6" x2="20" y2="6" />
          <circle cx="15" cy="12" r="2" />
          <line x1="4" y1="12" x2="13" y2="12" />
          <line x1="17" y1="12" x2="20" y2="12" />
          <circle cx="8" cy="18" r="2" />
          <line x1="4" y1="18" x2="6" y2="18" />
          <line x1="10" y1="18" x2="20" y2="18" />
        </svg>
        <span>Filtros</span>
        <span
          *ngIf="hasActiveFilters"
          class="filters-clear-badge"
          (click)="$event.stopPropagation(); cleanFilter()"
          title="Limpar filtros"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="w-3 h-3"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </span>
      </button>

      <div class="search-group">
        <input
          [formControl]="searchControl"
          type="text"
          class="search-group__input"
          placeholder="Nome do colaborador"
          (keyup.enter)="search()"
        />
        <button class="search-group__btn bg-blumine" (click)="search()">
          <img class="w-4 h-4" src="./assets/icons/search_white.svg" alt="" />
          <span>Pesquisar</span>
        </button>
      </div>

      <div class="filters-toolbar__actions">
        <button
          *isAllowed="[ERoleAdminString.Master, ERoleAdminString.Admin, 'collaborator-reports.export']"
          class="toolbar-btn btn btn--primary toolbar-btn--excel"
          (click)="exportModal.open()"
        >
          <img class="w-4 h-4" src="./assets/icons/download.svg" alt="" />
          <span>Exportar</span>
        </button>
      </div>
    </div>

    <div class="filter-panel" *ngIf="showFilters">
      <div class="filter-panel__field">
        <label class="filter-panel__label">Ordenação Funcionário</label>
        <ng-select
          [items]="listOrder"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          [formControl]="orderControl"
          appendTo="body"
        ></ng-select>
      </div>

      <div class="filter-panel__field" *ngIf="canFilterByCompany">
        <label class="filter-panel__label">Empresa</label>
        <ng-select
          [items]="companyOptions"
          bindLabel="name"
          bindValue="name"
          [clearable]="false"
          [searchable]="true"
          appendTo="body"
          [formControl]="companyFilterControl"
        ></ng-select>
      </div>

      <div class="filter-panel__field">
        <label class="filter-panel__label">Status do cartão</label>
        <ng-select
          [items]="cardStatusOptions"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          appendTo="body"
          [formControl]="cardStatusControl"
        ></ng-select>
      </div>

      <div class="filter-panel__field">
        <label class="filter-panel__label">Situação</label>
        <ng-select
          [items]="statusFuncionarioOptions"
          bindLabel="label"
          bindValue="value"
          [clearable]="false"
          [searchable]="false"
          appendTo="body"
          [formControl]="statusFuncionarioFilterControl"
        ></ng-select>
      </div>

      <div class="filter-panel__footer">
        <button class="filter-panel__clear" (click)="cleanFilter(); showFilters = false">
          <img class="w-4 h-4" src="./assets/icons/backspace_white.svg" alt="" />
          <span>Limpar</span>
        </button>
        <button class="filter-panel__apply bg-blumine" (click)="search(); showFilters = false">
          <img class="w-4 h-4" src="./assets/icons/search_white.svg" alt="" />
          <span>Filtrar</span>
        </button>
      </div>
    </div>
  </div>

  <div class="inline-block w-full mt-8">
    <app-list-collaborator-report
      [collaboratorReports]="collaboratorReports"
      [dadosPaginacao]="dadosPaginacao"
      (mudouPagina)="mudouPagina($event)"
      (mudouTamanhoPagina)="mudouTamanhoPagina($event)"
    ></app-list-collaborator-report>
  </div>

  <hr class="my-10" />
</div>

<app-export-collaborator-report
  #exportModal
  [companyOptions]="companyOptions"
  [currentOrderBy]="dadosPaginacao.ordenacao"
></app-export-collaborator-report>
